




















































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import VerificationPicker from "@/view/shared-components/VerificationPicker.vue";
import {mapGetters} from "vuex";
import CustomDatePicker from "@/view/shared-components/CustomDatePicker.vue";


@Component({
    components: {CustomDatePicker, VerificationPicker},
    computed: {
        ...mapGetters(['getGroups']),
    }
})

export default class HoldActionTracker extends Vue {
    @Prop({required: true}) holdTicket!: HoldTicket;

    quantityChanged(){
        this.$emit('recalculateTotalQty')
    }
}
